import Navbar from "../navBar/Navbar.jsx";
import Intro from "../heroSection/Intro";
import About from "../IntroSection/About";
import Skills from "../ExpertiseSection/Skills";
import Projects from "../projects/Projects";
import Experience from "../experience/Experience";
import Blank from "../blank/Blank.jsx";
import { Contact } from "../ContactMe/Contact";
import { ParallaxProvider } from "react-scroll-parallax";
import { motion } from "framer-motion";

function HomePage() {
  window.addEventListener("scroll", function () {
    var scrolledPixels = window.scrollY;
    console.log("Scrolled pixels: " + scrolledPixels);
  });
  return (
    <ParallaxProvider>
      <motion.div className="hero">
        <Intro />
        <About />
        <Skills />
        <Blank />
        <Projects />
        <Experience />
        <Contact />
      </motion.div>
    </ParallaxProvider>
  );
}

export default HomePage;
